// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0ae63da8","453":"b0cd54fe","876":"385ebe29"}[chunkId] + ".chunk.js";
};